// Mock data for JCM Capital website

export const whyWorkWithMe = [
  {
    id: 1,
    title: "Your Success is My Mission",
    content: "As a dedicated mortgage broker, I'm committed to understanding your unique financial situation and property goals. Every client receives personalized attention and tailored strategies.",
    icon: "Target"
  },
  {
    id: 2,
    title: "Tax & Wealth Expertise",
    content: "I specialize in structuring loans that maximize your tax benefits while accelerating wealth creation. From negative gearing to depreciation strategies, I'll show you how to keep more of your money.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Access to Premium Lenders",
    content: "With access to 40+ lenders including major banks and specialist lenders, I'll find you competitive rates and loan features that match your needs - often better than going direct.",
    icon: "Building"
  },
  {
    id: 4,
    title: "Support Every Step",
    content: "From initial consultation through to settlement and beyond, I'm here to guide you. No question is too small, and I'll explain everything in plain English.",
    icon: "Heart"
  }
];

export const residentialServices = [
  {
    id: 1,
    title: "First Home Buyers",
    description: "Taking your first step into property ownership? I'll guide you through every stage - from pre-approval to settlement. Access first home buyer grants, stamp duty concessions, and low deposit options. Let's make your dream of homeownership a reality.",
    icon: "Home",
    features: ["First Home Owner Grant assistance", "Low deposit options (5-10%)", "Stamp duty concessions", "Government schemes & guarantees"]
  },
  {
    id: 2,
    title: "Investors",
    description: "Build your property portfolio with strategic financing. Maximize tax benefits through negative gearing, access interest-only loans, and structure multiple properties for optimal cash flow and wealth creation.",
    icon: "TrendingUp",
    features: ["Negative gearing strategies", "Interest-only options", "Portfolio lending", "Tax-effective structuring"]
  },
  {
    id: 3,
    title: "Refinancing",
    description: "Lower your interest rate, access equity, or consolidate debt. Refinancing can save you thousands annually while improving your cash flow and loan features.",
    icon: "RefreshCw",
    features: ["Lower interest rates", "Access home equity", "Better loan features", "Improved cash flow"]
  },
  {
    id: 4,
    title: "Debt Consolidation",
    description: "Simplify your finances by consolidating credit cards, personal loans, and other debts into one manageable loan with a lower interest rate. Reduce stress and save money.",
    icon: "Layers",
    features: ["Single manageable payment", "Lower interest rates", "Improved credit score", "Reduced financial stress"]
  },
  {
    id: 5,
    title: "Family Pledge & Guarantors",
    description: "Parents can help without handing over cash. Use existing property equity as security to help your children buy their first home - avoiding lenders mortgage insurance.",
    icon: "Users",
    features: ["No lenders mortgage insurance", "No cash deposit needed", "Parents keep their property", "Guarantee can be removed"]
  },
  {
    id: 6,
    title: "Construction Loans",
    description: "Building your dream home? Get progress payments aligned with construction stages, interest-only during building, and competitive rates for new builds.",
    icon: "Hammer",
    features: ["Progress payment draws", "Interest-only during construction", "Land + construction packages", "Builder warranty requirements"]
  },
  {
    id: 7,
    title: "Equity Release",
    description: "Unlock the equity in your home for renovations, investments, or other purposes. Access your wealth without selling your property.",
    icon: "DollarSign",
    features: ["Access property wealth", "Renovations & improvements", "Investment opportunities", "Flexible repayment options"]
  },
  {
    id: 8,
    title: "SMSF Loans",
    description: "Use your superannuation to invest in residential or commercial property. Build retirement wealth with tax-effective SMSF property lending.",
    icon: "Shield",
    features: ["Limited recourse borrowing", "Residential & commercial", "Tax-free in pension phase", "Expert SMSF guidance"]
  }
];

export const commercialServices = [
  {
    id: 9,
    title: "Commercial Property",
    description: "Finance for offices, warehouses, retail spaces, and commercial real estate. Competitive rates for owner-occupied and investment commercial properties.",
    icon: "Building",
    features: ["Owner-occupied & investment", "Up to 70% LVR", "Flexible terms", "Quick approvals"]
  },
  {
    id: 10,
    title: "Invoice Finance",
    description: "Improve cash flow by accessing funds tied up in unpaid invoices. Get paid faster without waiting 30-90 days for customer payments.",
    icon: "FileText",
    features: ["Immediate cash flow", "Up to 90% of invoice value", "No waiting for payments", "Flexible facility"]
  },
  {
    id: 11,
    title: "Operational Leases",
    description: "Lease vehicles and equipment without upfront capital. Preserve cash flow while accessing the assets your business needs to operate.",
    icon: "Truck",
    features: ["No upfront capital", "Tax-deductible payments", "Preserve cash reserves", "Flexible terms"]
  },
  {
    id: 12,
    title: "Franchise Finance",
    description: "Specialized financing for buying or expanding franchise businesses. Access to lenders who understand franchise models and cash flows.",
    icon: "Store",
    features: ["Franchise-specific lenders", "Up to 80% purchase price", "Working capital included", "Fast approvals"]
  },
  {
    id: 13,
    title: "Business Loans",
    description: "Unsecured and secured business loans for growth, equipment, working capital, or expansion. Flexible funding solutions tailored to your business.",
    icon: "Briefcase",
    features: ["Working capital", "Business expansion", "Equipment purchase", "Flexible repayments"]
  },
  {
    id: 14,
    title: "Commercial SMSF",
    description: "Use your SMSF to purchase commercial property for your business. Pay rent to your super fund and build retirement wealth.",
    icon: "Building2",
    features: ["Buy your business premises", "Tax-effective structure", "Pay rent to your SMSF", "Build retirement wealth"]
  },
  {
    id: 15,
    title: "Shop Fit-Outs",
    description: "Finance the fit-out of retail, hospitality, or commercial spaces. Get your business operational with flexible fit-out funding.",
    icon: "Paintbrush",
    features: ["Retail & hospitality fit-outs", "Include equipment & fixtures", "Flexible repayment terms", "Quick approval process"]
  },
  {
    id: 16,
    title: "Vehicle & Equipment",
    description: "Finance or lease vehicles, machinery, and equipment for your business. Preserve cash flow while accessing essential business assets.",
    icon: "Truck",
    features: ["Cars, trucks, machinery", "Chattel mortgage or lease", "Tax benefits", "Balloon payments available"]
  }
];

export const taxStrategies = [
  {
    id: 1,
    title: "Negative Gearing",
    description: "Reduce your taxable income by offsetting property losses against your salary. Perfect for high-income earners building wealth.",
    icon: "Calculator",
    tip: "💡 Tip: Every $1 in rental loss can save you up to 47 cents in tax (including Medicare levy) for top tax bracket earners."
  },
  {
    id: 2,
    title: "Depreciation Benefits",
    description: "Claim thousands in tax deductions from building wear and tear, fixtures, and fittings - without spending a cent.",
    icon: "TrendingDown",
    tip: "💡 Tip: A depreciation schedule can uncover $5,000-$20,000+ in first-year deductions for investment properties."
  },
  {
    id: 3,
    title: "Offset Accounts",
    description: "Reduce interest charges while keeping your loan tax-deductible. Every dollar in offset saves you interest without affecting deductibility.",
    icon: "Wallet",
    tip: "💡 Tip: $50,000 in an offset account at 6% saves you $3,000/year in interest - that's tax-free savings!"
  },
  {
    id: 4,
    title: "Debt Recycling",
    description: "Convert non-deductible home loan debt into tax-deductible investment debt. Accelerate wealth while reducing tax.",
    icon: "Repeat",
    tip: "💡 Tip: Debt recycling can potentially save $2,000-$5,000+ annually in tax while building your investment portfolio."
  }
];

export const faqs = [
  {
    id: 1,
    question: "How can I pay off my loan faster while saving on tax?",
    answer: "Use offset accounts to reduce interest while maintaining tax deductibility, make extra payments when possible, and consider fortnightly payments instead of monthly (this creates one extra payment per year). We also help structure loans to maximize deductions while accelerating repayment."
  },
  {
    id: 2,
    question: "What is negative gearing and how does it benefit me?",
    answer: "Negative gearing occurs when your investment property costs (loan interest, maintenance, etc.) exceed rental income. This 'loss' reduces your taxable income, lowering your tax bill. Combined with capital growth, it's a powerful wealth-building strategy, especially for high-income earners."
  },
  {
    id: 3,
    question: "Can I use my SMSF to buy investment property?",
    answer: "Yes! SMSF property lending allows you to use your superannuation to invest in residential or commercial property. Benefits include tax-free rental income in pension phase and building retirement wealth through property."
  },
  {
    id: 4,
    question: "Should I choose principal & interest or interest-only repayments?",
    answer: "For owner-occupied: P&I is usually best to build equity faster. For investment properties: Interest-only can maximize tax deductions and cash flow, but you need a strategy for eventual repayment. We'll help determine what's right for your situation."
  },
  {
    id: 5,
    question: "How much can I save with the right loan structure?",
    answer: "Clients typically save $5,000-$50,000+ over the life of their loan through better rates, optimal structures, and tax strategies. Our approach focuses on saving you money while accelerating your wealth-building journey."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Wealth Building Focus",
    description: "We don't just arrange loans - we create comprehensive strategies to help you build wealth through property while minimizing tax.",
    icon: "Trophy"
  },
  {
    id: 2,
    title: "Tax Optimization Experts",
    description: "Our deep understanding of tax strategies means you keep more money in your pocket and accelerate your property portfolio growth.",
    icon: "PiggyBank"
  },
  {
    id: 3,
    title: "Personalized Service",
    description: "Every client gets a custom strategy tailored to their goals, whether you're a first-home buyer or seasoned investor.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Fast & Transparent",
    description: "Quick approvals, honest advice, no hidden fees. We're with you every step from application to settlement and beyond.",
    icon: "Zap"
  }
];

import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Submit contact form
export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(`${API}/contact`, formData);
    return {
      success: true,
      message: "Thank you! We'll contact you within 24 hours to discuss your property finance goals.",
      data: response.data
    };
  } catch (error) {
    console.error("Error submitting contact form:", error);
    return {
      success: false,
      message: "Something went wrong. Please try emailing us directly at joshua@jcmcapital.com.au",
      error: error.message
    };
  }
};

// Capture calculator lead
export const captureCalculatorLead = async (calculatorType, inputs, results, userEmail = null) => {
  try {
    const response = await axios.post(`${API}/calculator-lead`, {
      calculator_type: calculatorType,
      inputs,
      results,
      user_email: userEmail
    });
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error("Error capturing calculator lead:", error);
    return {
      success: false,
      error: error.message
    };
  }
};
